import { render, staticRenderFns } from "./ManagerialActivities.vue?vue&type=template&id=5a024460&"
import script from "./ManagerialActivities.vue?vue&type=script&lang=js&"
export * from "./ManagerialActivities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports